module.exports = __webpack_public_path__ + "img/zero-fees.5a6bddfe.svg";